import React, {ReactNode} from "react";

import {NotResideAdmin} from "../admin-roles";
import {StartWorkflowButton} from "../start-workflow";

import "./AdminActionRow.scss";

/** Action row adjustable to suit the needs of your page. You can pass it custom components for searching, filtering or facility selector. */
export const AdminActionRow = ({
  filter = null,
  search = null,
  actions = null,
  withCreateNewButton = true,
  listTileViewSwitch = null,
}: {
  filter?: ReactNode;
  search?: ReactNode;
  actions?: ReactNode;
  listTileViewSwitch?: ReactNode;
  withCreateNewButton?: boolean;
}) => (
  <div className="admin-action-row">
    <div className="search">{search}</div>
    <div className="filter">{filter}</div>
    <div className="right-side">
      <div className="actions">{actions}</div>
      <div className="facility-dropdown">
        {withCreateNewButton && (
          <NotResideAdmin>
            <StartWorkflowButton />
          </NotResideAdmin>
        )}
      </div>
    </div>
    <div className="list-tile-view-switch">{listTileViewSwitch}</div>
  </div>
);
